import blueBg from "assets/images/invoice-qr-blue-bg.png";

export const styles = {
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#F5F8FF",
    width: 300,
    backgroundImage: `url(${blueBg})`,
    backgroundSize: "100% 70%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top",

    "@media (max-width: 380px)": {
      width: "100%",
    },
  },

  cardContent: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px 16px 36px",
    gap: 2,
  },
};
